const customHeaders = new Headers({
  'Content-Type': 'text/plain',
});

/**
 * take html(in text) from url
 */
export const httpGetHTML = async (url: string, headers = customHeaders) => {
  const httpParameters = { method: 'GET', headers };
  const response = await fetch(url, httpParameters);
  const data = await response.text();
  const status = response.status;
  return { data, status };
};
